export const accountabilityAgreement = (name?: string, date?: string) => {
  return [
    { text: 'Accountability Agreement', style: 'h1' },

    { text: "To ensure continued operation of Sierra Expediting Inc.'s Motor Carrier Authority and remain insurable, it is necessary for Sierra to maintain an acceptable safety score, which is maintained and monitored by the Federal Motor Carrier Safety Administration. Therefore, Sierra implements a Safety Incentive Program which includes but is not limited to the following procedures applicable to transportation of loads pursuant to this agreement:", style: 'p' },

    { text: "Safety Incentive Program", style: 'p', bold: true },

    { text: "Employees and owner operators assigned to driving duties under Sierra Expediting", style: 'p' },

    { text: "• drivers must have a current, valid commercial driver's licen", style: 'p' },

    { text: "• drivers must maintain a clean driving record, i.e., must remain insurable under Sierra Expediting 's liability insurance policy.", style: 'p' },

    { text: "Any driver operating Sierra Expediting vehicles and/or equipment must abide by all applicable rules and regulations set forth by the Federal Motor Carrier Safety Administration of the Department of Transportation and must observe all safety, traffic, and criminal laws in all states and local jurisdictions.", style: 'p' },

    { text: "Anything a driver does in connection with the operation of motor vehicles can affect that driver's fitness for duty or insurability as a driver. Regardless of fault, circumstance, on- or off-duty status, time, or place, any driver who receives a traffic citation from or is arrested by a law enforcement officer, or who is involved in any kind of accident while driving, must inform the Safety Department immediately. If an incident occurs after normal business hours, drivers must inform after hours dispatch immediately. Any penalty, fine, imprisonment, fee, or other adverse action imposed by a court in connection with such an incident must also be reported immediately. In both above situations, the matter will be assessed against Sierra Expediting’s insurance policy so that a prompt decision on continued coverage of the driver can be made.", style: 'p' },

    { text: "The driver involved in an accident or cited by a law enforcement official for violating a motor vehicle law must turn over any documentation relating to such incident as soon as possible to the Safety Department and must cooperate fully with Management in verifying the information with other parties involved and with law enforcement authorities. While parking tickets will not affect a driver's fitness or insurability, any parking ticket issued on a vehicle operating under Sierra authority should be reported to the Safety Department at the earliest possible opportunity.", style: 'p' },

    { text: "Drivers are required to perform Pre-Trip and/ or Post-Trip inspections every day to be compliant with Section § 396.11 of FMCSA regulations, and to certify that their assigned Sierra Expediting vehicle and equipment is safe to operate and is fully compliant with all Federal, State, and Local laws. If damage, defects, deficiencies, or malfunctions are identified, drivers must annotate the information in detail on the Driver Vehicle Inspection Report, notify appropriate supervisor, and make a good faith effort to complete all repairs as soon as possible.", style: 'p' },

    { text: "Any driver who violates any motor vehicle law, any DOT regulation, any part of this policy, or becomes uninsurable as a driver, may be subject to financial penalties.", style: 'p' },

    // { text: "• Safe Driving Bonuses to be paid monthly as follows:", style: 'p', bold: true },
    //
    // { text: [
    //     { text: '- Level 3 ', bold: true },
    //     { text: "Inspections without Violations - $50 for each clean inspection"}
    //   ], style: 'p', margin: [20, 0, 0, 0] },
    // { text: [
    //     { text: '- Level 2 ', bold: true },
    //     { text: "Inspections without Violations - $75 for each clean inspection"}
    //   ], style: 'p', margin: [20, 0, 0, 0] },
    // { text: [
    //     { text: '- Level 1 ', bold: true },
    //     { text: "Inspection without Violations - $100 for each clean inspection"}
    //   ], style: 'p', margin: [20, 0, 0, 10] },

    // { text: "Financial Penalties for Inspections with Violations, due to driver’s fault and negligence, are as follows: Level 3, Level 2, and Level 1 Inspections with Violation(s):", style: 'p' },

    { text: "These penalties apply whether or not a law enforcement officer issued a citation. Sierra is required to maintain compliance with FMCSA regulations to remain insurable and authorized to operate. Drivers are responsible for ensuring their logs are accurate and compliant at all times.", style: 'p' },

    { text: "Hours of Service Violations", style: 'p', margin: [20, 0, 0, 10], bold: true },

    { text: "- 1st offense: $100 per violation", style: 'p', margin: [40, 0, 0, 0] },
    { text: "- 2nd offense: $200 per violation", style: 'p', margin: [40, 0, 0, 0] },
    { text: "- 3rd offense: Termination", style: 'p', margin: [40, 0, 0, 10] },

    { text: "Unsafe driving/Speeding ticket", style: 'p', margin: [20, 0, 0, 10], bold: true },

    { text: "- 1st offense: $100 per violation", style: 'p', margin: [40, 0, 0, 0] },
    { text: "- 2nd offense: $200 per violation", style: 'p', margin: [40, 0, 0, 0] },
    { text: "- 3rd offense: Termination", style: 'p', margin: [40, 0, 0, 10] },

    { text: "Maintenance/Driver Fitness", style: 'p', margin: [20, 0, 0, 10], bold: true },

    { text: "- 1st offense: $75 per violation", style: 'p', margin: [40, 0, 0, 0] },
    { text: "- 2nd offense: $100 per violation", style: 'p', margin: [40, 0, 0, 0] },
    { text: "- 3rd offense: $500 per violation and/or termination", style: 'p', margin: [40, 0, 0, 10] },

    { text: "'Out of Service' Violation Penalty", style: 'p', margin: [20, 0, 0, 10], bold: true },

    { text: "- 1st offense per quarter: $300", style: 'p', margin: [40, 0, 0, 0] },
    { text: "- 2nd offense per quarter: $500", style: 'p', margin: [40, 0, 0, 0] },
    { text: "- 3rd offense: $1000 and/or TERMINATION", style: 'p', margin: [40, 0, 0, 10] },

    { text: "Regardless of inspection level, each Violation Severity point may result in a $15.00 per point fine added to the total penalty amount.", style: 'p' },

    { text: "Drivers will receive warnings for violating both company policies and DOT regulations. Non-compliance with these rules may result in disciplinary actions and fines.", style: 'p' },

    { text: "All penalties subject to change at the discretion of the Safety Department.", style: 'p' },

    { text: [
        { text: 'I, '},
        { text: ` ${name}, `, bold: true },
        { text: "hereby confirm that I have read, understand, and agree to the above policy."}
      ], style: 'p' },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 200,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 350,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
      margin: [0, 40, 0, 0]
    },

    { text: "Driver's Signature", style: 'label', margin: [0, 2, 0, 0] },
    { text: `${date}`, margin: [350, -32, 0, 0] },
    { text: "Date", style: 'label', margin: [350, 5, 0, 0] },

    { text: '', pageBreak: 'before' },
  ];
};